import { render } from "./CreditBasicComponent.vue?vue&type=template&id=52840f83&scoped=true"
import script from "./CreditBasicComponent.vue?vue&type=script&lang=js"
export * from "./CreditBasicComponent.vue?vue&type=script&lang=js"

import "./CreditBasicComponent.vue?vue&type=style&index=0&id=52840f83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52840f83"]])

export default __exports__